"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHttpErroHandler = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var icominds_lib_1 = require("@greatmindsorg/icominds-lib");
var Common_1 = require("../../../modules/Common");
var HttpErrorHandlerContext = /** @class */ (function () {
    function HttpErrorHandlerContext(strategy) {
        var _this = this;
        this.setStrategy = function (strategy) {
            _this.strategy = strategy;
        };
        this.handle = function () { return _this.strategy.handle(); };
        this.strategy = strategy;
    }
    return HttpErrorHandlerContext;
}());
/**
 * Http Error Handler strategies
 */
var useBadRequestHandler = function () { return ({
    handle: function () {
        window.location.href = '/';
    },
}); };
var useServerErrorHandler = function () {
    var publish = (0, react_1.useContext)(Common_1.AlertManagerContext).publish;
    var t = (0, react_i18next_1.useTranslation)().t;
    var renderErrorMsg = function () { return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(icominds_lib_1.Icon, { name: "warning" }), (0, jsx_runtime_1.jsx)("span", { children: t('components.header.logoutErrorMsg') })] })); };
    var handle = function () {
        return publish(Common_1.AlertOptions.warning({
            alert: {
                message: renderErrorMsg(),
            },
        }));
    };
    return { handle: handle };
};
/**
 * Main hook
 * @param error
 * @returns
 */
var useHttpErroHandler = function () {
    var badRequestHandler = useBadRequestHandler();
    var serverErrorHandler = useServerErrorHandler();
    var handleHTTPError = function (error) {
        var context = new HttpErrorHandlerContext(serverErrorHandler);
        if (error.response.status === 400)
            context.setStrategy(badRequestHandler);
        if (error.response.status === 500)
            context.setStrategy(serverErrorHandler);
        return context.handle;
    };
    return { handleHTTPError: handleHTTPError };
};
exports.useHttpErroHandler = useHttpErroHandler;
